import classNames, { ArgumentArray } from "classnames"
import { twMerge } from "tailwind-merge"

/**
 * Function which combines twMerge and classNames. Please do not use this in app. Instead use `cn` function
 */
export const oysterClassNames = (...classNamesArgs: ArgumentArray) => {
  return twMerge(classNames(classNamesArgs))
}
